module.exports = __webpack_public_path__ + "static/media/javaIcon.1e1ba20c.png";